import { Injectable } from '@angular/core';

import { DataEntry } from '@osos/shared/api';
import { ParserBase } from '../../bases/parser/parser-base';

import { DataEntryPresenterModel } from '@osos/shared/types';

@Injectable()
export class DataEntryParserV1Service extends ParserBase<
  DataEntry,
  DataEntryPresenterModel
> {
  constructor() {
    super(DataEntry, DataEntryPresenterModel, 1);
  }
  getPresenterModel(model: DataEntry): DataEntryPresenterModel {
    return {
      specificationVersion: this.version,
      id: model.id,
      dataEntity: model.dataEntity,
      value: model.value,
      state: model.state,
      creationInfo: model.creationInfo,
      updateInfo: model.updateInfo,
      entityVersion: model.entityVersion ?? 0,
      isEntryObsolete: model.invalidReason === 0,
      isEntryInvalid: model.invalidReason === 1,
      isImplicit: model.isImplicit,
    } as DataEntryPresenterModel;
  }
  getDataModel(presenter: DataEntryPresenterModel): DataEntry {
    const model = {
      specificationVersion: this.version,
      // dataEntity: presenter.dataEntity,
      value: { ...presenter.value },
      // state: presenter.state,
    } as DataEntry;

    return model;
  }
}
